export function integerToCurrency(amount) {
  if (amount == null) {
    return "-";
  }

  const formatter = new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
    minimumFractionDigits: 2,
  });

  return formatter.format(amount);
}